
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.352 11.018c-.271.328-.573.602-.907.82a5.283 5.283 0 01-1.101.54l-.32-.891c.52-.182.986-.477 1.398-.883L3.414 8.323v-.75L8.43 5.26a3.298 3.298 0 00-.594-.484 4.065 4.065 0 00-.805-.422l.36-.867c.385.15.731.33 1.039.539.312.208.627.476.945.805l2.68-1.243.46 1.008-2.53 1.164c.223.344.385.69.484 1.04.099.343.148.713.148 1.109 0 .4-.057.784-.172 1.148-.11.36-.263.708-.46 1.047l2.53 1.156-.46 1.008-2.703-1.25zm-.305-1.344a3.5 3.5 0 00.375-.843c.083-.282.125-.584.125-.907a3.04 3.04 0 00-.125-.883 3.63 3.63 0 00-.367-.851L5.14 7.932l3.906 1.742z","fill":"#748190"}})])
          )
        }
      }
    